import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=84897cec&scoped=true&"
import script from "./RoleSelect.vue?vue&type=script&lang=js&"
export * from "./RoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelect.vue?vue&type=style&index=0&id=84897cec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84897cec",
  null
  
)

export default component.exports